module.exports = __webpack_public_path__ + "img/middle-Market.c10680fd.png";